/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Prospecting1Inputs */

const en_coinvestments_insights_col_prospecting1 = /** @type {(inputs: Coinvestments_Insights_Col_Prospecting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospecting`)
};

/**
* | output |
* | --- |
* | "Prospecting" |
*
* @param {Coinvestments_Insights_Col_Prospecting1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_prospecting1 = /** @type {((inputs?: Coinvestments_Insights_Col_Prospecting1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Prospecting1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_prospecting1(inputs)
});
export { coinvestments_insights_col_prospecting1 as "coInvestments_insights_col_prospecting" }